<template>

  <div id="footer-info">

    <div class="">
      <div class="texture">

        <div class="personal-data">
          <div class="place">
            <span>East Darrin</span> <span>Norway</span> <span>923 Maida Pines Apt. 923</span>
          </div>
          <div class="numbers">
            <span>956-127-2252</span> <span>20144-9335</span>
          </div>
        </div>

        <div class="social">
          <span>Seguici su</span>
          <div class="">
            <div class="logos">
              <div class="logo ig w-image">
                <img :src="url('/media/icons/png/instagram.png')" alt="">
              </div>
              <div class="logo fb w-image">
                <img :src="url('/media/icons/png/facebook.png')" alt="">
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>


  </div>


</template>

<script>
export default{

  data: function(){
    return {

    }
  },

  computed: {

  },

  methods: {

  }

}
</script>

<style scoped>
#footer-info{
  margin-top: 2em;
}
#footer-info .texture {
  color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
#footer-info .texture .personal-data{

}
#footer-info .texture .social{

}
#footer-info .texture .social .logos{
  display: flex;
  padding-top: 0.5em;
}
#footer-info .texture .social .logos .logo{
 width: 20px;
 margin-right: 16px;
}
#footer-info .texture .social .logos .logo img {
  width: inherit;
  height: auto;
}
</style>
